module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAVZJREFUOE/VlL1xwkAQhd9epBB34BJwB7gDd2AU7SmjA+MKjCPpSKADoALkDnAFxh0ohWDXsxodwwAyM7ITNlzd+/ZfNJvNervdbkFEA3S3CsCEmV+pKIolEfVEZNyV55zrAZiLyIhCCCoij1mWlV2BpgshzAFs/xNYV3iDwBDCWES2WZZZT2BbsN/vXwB8MPOyzWe6s5LzPB8459b2gZmpafYIwNuJz8QWpGLmu+bdObDJZqmqG++9gZDn+T0RWWZl9E2n076IzM3PzDXoYoZ/XJsbmrLd4TBOsGvZRVFsrKd2yxMierbjPoapauW9fz8NYENyztn7g6mqDW5IRA/Hq/F0Iu6r6sJ7n0a/TVdV16r6TURWWW0WXFUn9j+ogZesEZcR2qzUF4AVMw/bdK1AExxDiagP4PM3WH0p14YQoQBsiVszi5yrwHgtSZJUaZoe+taWyA9D7hd/uN7PUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/news.png
// module id = d/6q
// module chunks = 3